import React, {Component, PureComponent} from "react";
import Accordion from 'react-bootstrap/Accordion';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlusSquare, faMinusSquare} from '@fortawesome/free-solid-svg-icons';
import {helper} from "../app";

export default class ProjectStructure extends Component 
{
    fragment = 0;
    constructor (props)
    {
        super(props);        

        this.fragment = this.props.fragment;

        this.state = {
            fragment: this.props.fragment
        }        

        this.showFragment = this.showFragment.bind(this);
    }
    showFragment (fragment)
    {
        this.setState({fragment});
    }
    render () 
    {
        const haveProject = !helper.isNotObjectOrEmpty(this.props.project),
            activeFragment = this.state.fragment,//this.fragment != this.props.fragment ? this.props.fragment : this.state.fragment,
            structureList = haveProject ? Object.keys(this.props.project).map(fragmentID => 
            {
                const fragmentName = this.props.project[fragmentID].name,
                    fragmentGroups = this.props.project[fragmentID].groups;

                return <div key={`ps_f${fragmentID}`}>
                    <Accordion.Toggle as="div" className="mb-3" eventKey={fragmentID}>
                        <FontAwesomeIcon icon={fragmentID == activeFragment ? faMinusSquare : faPlusSquare} />{`   
                        `}<span className="h5" role="button">{fragmentName}</span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={fragmentID} className={fragmentID == activeFragment ? 'show' : ''}>
                        <ul className="list-unstyled">
                            {Object.keys(fragmentGroups).map(groupName => 
                            {
                                const groupProducts = fragmentGroups[groupName];
                                return <li key={`ps_g${groupName}`} className="mb-2">
                                    <h6>{groupName}</h6>
                                    <ul className="list-unstyled">
                                        {Object.keys(groupProducts).map(productID => 
                                        {
                                            const product = groupProducts[productID];
                                            return <li key={`ps_p${productID}`}>{`${product.data.articul} ${product.data.name}; ${product.quantity}шт`}</li>;
                                        })}
                                    </ul>
                                </li>;
                            })}
                        </ul>
                    </Accordion.Collapse>  
                </div>
            }) : [];

        return (haveProject 
            ? <Accordion onSelect={this.showFragment} activeKey={activeFragment}>
                {structureList}
            </Accordion>
            : <>{'Пустой проект'}<br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /></>
        );
    }
    componentDidUpdate () 
    {
        this.fragment = this.props.fragment;
    }
}/*
let haveAnything = false,
    trayItems = [],
    accessoryItems = [],
    shoreItems = [];

for (let projectItems of this.props.project.values()) 
{
    if (!helper.isNotObjectOrEmpty(projectItems['tray']))
    {
        const tray = projectItems['tray'];
        trayItems.push(<li key={`t_${tray.id}`}>{`${tray.articul} ${tray.name}; ${tray.quantity}шт, ${tray.length*tray.quantity}м`}</li>);
        
        if ('tray_cover' in projectItems && !helper.isNotObjectOrEmpty(projectItems['tray_cover']))
        {
            const cover = projectItems['tray_cover'];
            trayItems.push(<li key={`tc_${cover.id}`}>{`${cover.articul} ${cover.name}; ${cover.quantity}шт, ${cover.length*cover.quantity}м`}</li>);
        }
        haveAnything = true;
    }
    if (!helper.isNotObjectOrEmpty(projectItems['accessories']) && projectItems['accessories'].length)
    {
        projectItems['accessories'].forEach(accessoryItem => 
        {
            if (!helper.isNotObjectOrEmpty(accessoryItem))
            {
                const accessory = accessoryItem['accessory'];                        
                accessoryItems.push(<li key={`a_${accessory.id}`}>{`${accessory.articul} ${accessory.name}; ${accessory.quantity}шт`}</li>); // , ${accessory.length*accessory.quantity}м

                if ('accessory_cover' in accessoryItem && !helper.isNotObjectOrEmpty(projectItems['accessory_cover']))
                {
                    const cover = accessoryItem['accessory_cover'];
                    accessoryItems.push(<li key={`ac_${cover.id}`}>{`${cover.articul} ${cover.name}; ${cover.quantity}шт`}</li>); // , ${cover.length*cover.quantity}м
                }
                haveAnything = true;
            }
        });
    }
    if (!helper.isNotObjectOrEmpty(projectItems['shore_shelf']))
    {
        const shelf = projectItems['shore_shelf'];
        shoreItems.push(<li key={`t_${shelf.id}`}>{`${shelf.articul} ${shelf.name}; ${shelf.quantity}шт, ${shelf.length*shelf.quantity}м`}</li>);
        haveAnything = true;
    }
    if (!helper.isNotObjectOrEmpty(projectItems['shore_stud']))
    {
        const stud = projectItems['shore_stud'];
        shoreItems.push(<li key={`t_${stud.id}`}>{`${stud.articul} ${stud.name}; ${stud.quantity}шт, ${stud.length*stud.quantity}м`}</li>);
        haveAnything = true;
    }
    break;
}




<Accordion.Toggle as="div" eventKey="1">
    <FontAwesomeIcon icon={faPlusSquare} />{'   Фрагмент 2'}
</Accordion.Toggle>
<Accordion.Collapse eventKey="1">
<ul className="list-unstyled">
    <li className="mb-2">
        <h6>Лоток</h6>
        <ul className="list-unstyled">
            <li>к ЛНМЗТ(М)-ЗООх100пр Металлический лоток неперфорированный 300x100x2500; 8 шт., 20 м.</li>
        </ul>
    </li>
    <li>
        <h6>Аксессуары</h6>
        <ul className="list-unstyled">
            <li>к КЛЗТз-ЗОО Крышка к лотку 300x14x2500 под заземление; 8 шт., 20 м.</li>
            <li>к УВНТп-300х100 Угол внутренний плавный 90 град, к лотку 300x100; 10 шт.</li>
            <li>к КУВНТп-300 Крышка угла внутреннего плавного 90 град, к лотку 300; 10 шт.</li>
        </ul>
    </li>
</ul>
</Accordion.Collapse>
*/
/*
    <ul className="list-unstyled">
        {trayItems.length
            ? <li className="mb-2">
                <h6>Лоток</h6>
                <ul className="list-unstyled">
                    {trayItems}
                </ul>
            </li>
            : ''
        }{accessoryItems.length
            ? <li className="mb-2">
                <h6>Аксессуары</h6>
                <ul className="list-unstyled">
                    {accessoryItems}
                </ul>
            </li>
            : ''
        }{shoreItems.length
            ? <li>
                <h6>Подвесы</h6>
                <ul className="list-unstyled">
                    {shoreItems}
                </ul>
            </li>
            : ''
        }
    </ul>
    */